import React from "react";
import "./ReadmeBanner9May.css"
import qrArrow from "../../../img/qrArrow.svg"
import readMeQr from "../../../img/readme9MayQr.png"

function ReadmeBanner9May(){
    return (
        <div className="s-bg">
            <div className="readMeBanner-wrapper">
                <div className="readMeBanner-content-top">
                    держим связь
                </div>
                <div className="readMeBanner-content-left">
                    <div className="readMeBanner-content-title">
                        почитай мне<br />про подвиги и Победу
                    </div>
                    <div className="readMeBanner-content-smallText">
                        запиши историю подвига своим голосом<br />и поделись с близкими<br /><br />
                        скачай приложение и участвуй в акции<br />в честь 80-летия Победы
                    </div>
                    <img src={qrArrow} className="qrArrow" alt="почитай мне" />
                </div>
                <div className="readMeBanner-content-right">
                </div>
                <div className="readeMeQr">
                    <img src={readMeQr} alt="почитай мне" />
                </div>
            </div>
        </div>
    )
}

export default ReadmeBanner9May;